import { render, staticRenderFns } from "./Segurbon.vue?vue&type=template&id=3cbb1503&scoped=true"
import script from "./Segurbon.vue?vue&type=script&lang=js"
export * from "./Segurbon.vue?vue&type=script&lang=js"
import style0 from "./Segurbon.vue?vue&type=style&index=0&id=3cbb1503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbb1503",
  null
  
)

export default component.exports